module.exports = __webpack_public_path__ + "images/babb.6e158c5bc371f3d4978c56811cb65a0a.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/babb.png
// module id = 1014
// module chunks = 0